import { render, staticRenderFns } from "./B2CIcon.vue?vue&type=template&id=6899bb1c&scoped=true"
import script from "./B2CIcon.vue?vue&type=script&lang=js"
export * from "./B2CIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899bb1c",
  null
  
)

export default component.exports